module.exports = __webpack_public_path__ + "static/cloudsun-6a8c3f4c1c5e9833b80ebf4e465f8476.png";